<template>
  <el-container v-if="loading"></el-container>
  <el-container v-else>
    <sidebar :collapse="isCollapse"/>
    <el-container class="wrapper">
      <el-header>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-button size="medium" class="menu-btn" @click="isCollapse = !isCollapse"><i class="fa fa-bars" aria-hidden="true"></i></el-button>
          </el-col>

          <el-col :span="6" :hide-on-click="false" class="lang-selection">
            <a :href="analytics.href" data-qa="Header-Analytics-Link" :target="analytics.target" v-if="isAnalyticsEnabled" class="analytics-link">
              <el-button>
                {{ $t(analytics.text) }}
              </el-button>
            </a>
            <el-dropdown @command="dropdown.lang.command" :class="dropdown.lang.class" data-qa="Header-Lang-DropDown" :trigger="dropdown.lang.trigger">
              <el-button data-qa="Header-Lang-Button">
                {{ currentLang }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item.command" :data-qa="item['data-qa']" :id="item.id" :key="item.text" v-for="item in dropdown.lang.items">{{ item.text }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="handleCommand" class="user-dropdown" data-qa="Header-User-DropDown" trigger="click">
              <el-button data-qa="Header-User-Button">
                {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="solutionStatusTest" data-qa="Header-UserDropdown-Item-SolutionStatusTest" id="solutionStatusTest">{{ $t('dashUserDropDownSolutionTestText') }}</el-dropdown-item>
                <el-dropdown-item command="signOut" data-qa="Header-UserDropdown-Item-SignOut" divided id="signOut">{{ $t('dashUserDropDownSignOutText') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
          <solution-status-test></solution-status-test>
        </el-row>
      </el-header>

      <el-main>
        <router-view></router-view>
      </el-main>

      <el-footer>
        <div data-qa="Footer-ExositeCopyRight-Text">
          &copy; {{ year }}
          <a
            :href="footer.exosite.href"
            :target="footer.exosite.target"
            data-qa="Footer-ExositeCopyRight-Link"
          >
            {{ footer.exosite.text }}
          </a>.
          {{ $t(footer.copyRight.text) }}
        </div>
        <div class="links-group">
          <a data-qa="Footer-Documentation-Link-Documentation" :href="footer.documentation.href">{{ $t(footer.documentation.text) }}</a>
          <a data-qa="Footer-Support-Link-Support" :href="footer.support.href">{{ $t(footer.support.text) }}</a>
          <a data-qa="Footer-Terms-Link-Terms" :href="footer.terms.href">{{ $t(footer.terms.text) }}</a>
          <a data-qa="Footer-Privacy-Link-Privacy" :href="footer.privacy.href">{{ $t(footer.privacy.text) }}</a>
          <span :data-qa="`Footer-Version-Link-${footer.version}`" v-if="hasVersion">{{ currentVersion }}</span>
        </div>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
  import main from './Dash.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './Dash.scss'
</style>



// WEBPACK FOOTER //
// Dash.vue?1120b7c6